document.addEventListener("DOMContentLoaded", () => {

    // -----------------------------
    // Smooth Scroll Navigation
    // -----------------------------

    document.querySelectorAll(".guide-nav a").forEach(link => {

        link.addEventListener("click", function(e){

            const id = this.getAttribute("href");

            if(!id.startsWith("#")) return;

            const target = document.querySelector(id);

            if(!target) return;

            e.preventDefault();

         window.scrollTo({
    top: target.offsetTop - 110,
    behavior: "smooth"
});
        });

    });


    // -----------------------------
    // Active Navigation Highlight
    // -----------------------------

    const sections = document.querySelectorAll(".guide-section");

    const navLinks = document.querySelectorAll(".guide-nav a");

    function setActive(){

        let current = "";

        sections.forEach(section=>{

            const top = section.offsetTop - 180;

            if(window.scrollY >= top){

                current = section.getAttribute("id");

            }

        });

        navLinks.forEach(link=>{

            link.classList.remove("active");

            if(link.getAttribute("href") === "#" + current){

                link.classList.add("active");

            }

        });

    }

    setActive();

    window.addEventListener("scroll", setActive);

});